import React, { ReactNode } from "react";
import RootCloseWrapper from "react-overlays/lib/RootCloseWrapper";

const MenuContentFc: React.FC<{
	bsRole: string;
	children: ReactNode;
	additionalClasses?: string;
}> = ({ children, additionalClasses }) => {
	return (
		<div className={`dropdown-menu ${additionalClasses}`}>{children}</div>
	);
};

type MenuContentProps = {
	bsRole: string;
	additionalClasses?: string;
	open?;
	rootCloseEvent?: any;
	onClose?: any;
};

class MenuContent extends React.Component<MenuContentProps> {
	constructor(props, context) {
		super(props, context);
		this.handleRootClose = this.handleRootClose.bind(this);
	}

	handleRootClose(event) {
		this.props.onClose(event, { source: "rootClose" });
	}

	render() {
		const { open, rootCloseEvent, children } = this.props;
		return (
			<>
				<RootCloseWrapper
					disabled={!open}
					onRootClose={this.handleRootClose}
					event={rootCloseEvent}
				>
					<MenuContentFc
						additionalClasses={this.props.additionalClasses}
						bsRole="menu"
					>
						{children}
					</MenuContentFc>
				</RootCloseWrapper>
			</>
		);
	}
}

export default MenuContent;
